import React, { useEffect, useState } from "react";
import {
  dateFormat,
  fmtCurrency,
  clientFilterOptions,
} from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import {
  changeNavtitle,
  getProviderCredit,
  getProviderDetails,
  getRevenueData,
} from "../../features/user/userSlice";
import Spinner from "../../components/PageLoader";
import Icon from "../../components/Icon";
import Button from "../../components/Button";
import PassModal from "../../components/modal/PassModal";
import SuccessModal from "../../components/modal/SuccessModal";
import PassVerificationStatusModal from "../../components/modal/PassVerificationStatusModal";
import skeletonLoading from "../../assets/svgs/emptyBar.svg";
import {
  getClientActivity,
  getClientVisits,
  getProviderSubscribers,
  searchClient,
} from "../../features/clients/clientSlice";
import { useNavigate } from "react-router-dom";
import ActivityLog from "../../components/table/ActivityLog";
import ActiveBenefits from "../../components/ActiveBenefits";
import MobileTable from "../../components/table/MobileTable";
import PaginationWithApi from "../../components/PaginationWithApi";
import { hasPermission } from "../../utils/authHelpers";
import DashboardCardSection from "../../components/DashboardCardSection";
import ReverseTransactionModal from "../../components/modal/ReverseTransactionModal";

const filterOptions = [
  { name: "This Year", value: "THIS_YEAR" },
  { name: "This Week", value: "THIS_WEEK" },
  { name: "This Month", value: "THIS_MONTH" },
];
const Dashboard = () => {
  const [openFlancePassModal, setOpenFlancePassModal] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const [openFilterList, setOpenFilterList] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(filterOptions[0]);
  const [storedData, setStoredData] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [openClientFilterDropdown, setOpenClientFilterDropdown] =
    useState(false);
  const [
    selectedClientFilterDropdownItem,
    setSelectedClientFilterDropdownItem,
  ] = useState(clientFilterOptions[0]);
  const [isActivityLoading, setIsActivityLoading] = useState(false);
  const [openVerificationStatus, setOpenVerificationStatus] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState("invalid");
  const [verifiedClientName, setVerifiedClientName] = useState("");
  const [verificationErrorMessage, setVerificationErrorMessage] = useState("");
  const [clientType, setClientType] = useState("FLANCE,PROVIDER");

  const { isLoading, providerCredit, revenueData, user } = useSelector(
    (store) => store.user
  );
  const userRole = user?.data?.roleName;
  const {
    clients,
    clientVisit,
    clientActivity,
    clientSearch,
    isLoading: clLoading,
  } = useSelector((store) => store.client);
  const dispatch = useDispatch();
  const key = user?.data?.providerId;
  useEffect(() => {
    dispatch(getProviderCredit());
    dispatch(changeNavtitle("Dashboard"));
    dispatch(getProviderDetails());
  }, []);
  useEffect(() => {
    let tempClientType;
    if (selectedClientFilterDropdownItem.value === "ALL_CLIENTS") {
      setClientType("FLANCE,PROVIDER");
      tempClientType = "FLANCE,PROVIDER";
    } else if (selectedClientFilterDropdownItem.value === "MY_CLIENTS") {
      setClientType("PROVIDER");
      tempClientType = "PROVIDER";
    } else if (selectedClientFilterDropdownItem.value === "FLANCERS") {
      setClientType("FLANCE");
      tempClientType = "FLANCE";
    }

    if (storedData?.id) {
      setIsActivityLoading(true);
      dispatch(
        getClientActivity({
          clientType: tempClientType,
          page: currentPage,
          numPerPage: 7,
          branch: storedData?.id,
        })
      )
        .unwrap()
        .then(() => setIsActivityLoading(false))
        .catch(() => setIsActivityLoading(false));
    }
  }, [
    currentPage,
    storedData?.id,
    selectedClientFilterDropdownItem?.value,
    dispatch,
  ]);

  useEffect(() => {
    if (storedData?.id) {
      dispatch(getClientVisits({ branch: storedData?.id }));
    }
    dispatch(getProviderSubscribers({ branch: storedData?.id }));
  }, [storedData?.id]);

  const handleNext = () => {
    if (!clientActivity?.last) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
    }
  };

  const handlePrev = () => {
    if (currentPage > 0) {
      const prevPage = currentPage - 1;
      setCurrentPage(prevPage);
    }
  };

  const getFromLocalStorage = () => {
    try {
      const value = localStorage.getItem(`${key}branch`);

      if (value === null || value === undefined || value === "undefined") {
        return null; // Return null if the key doesn't exist
      }
      setStoredData(JSON.parse(value)); // Parse the JSON value
    } catch (error) {
      console.error("Error parsing JSON from localStorage", error);
      return null; // Return null if parsing fails
    }
  };

  useEffect(() => {
    getFromLocalStorage();
  }, [storedData]);

  useEffect(() => {
    if (selectedFilter?.value) {
      dispatch(getRevenueData(selectedFilter?.value));
    } else {
      dispatch(getRevenueData("THIS_YEAR"));
    }
  }, [selectedFilter?.value]);

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(searchClient(search));
  };
  // const [value, setValue] = useState();

  const yearlyRevenue = [
    { month: "Jan", revenue: revenueData?.barChartData?.JANUARY },
    { month: "Feb", revenue: revenueData?.barChartData?.FEBRUARY },
    { month: "Mar", revenue: revenueData?.barChartData?.MARCH },
    { month: "Apr", revenue: revenueData?.barChartData?.APRIL },
    { month: "May", revenue: revenueData?.barChartData?.MAY },
    { month: "Jun", revenue: revenueData?.barChartData?.JUNE },
    { month: "Jul", revenue: revenueData?.barChartData?.JULY },
    { month: "Aug", revenue: revenueData?.barChartData?.AUGUST },
    { month: "Sep", revenue: revenueData?.barChartData?.SEPTEMBER },
    { month: "Oct", revenue: revenueData?.barChartData?.OCTOBER },
    { month: "Nov", revenue: revenueData?.barChartData?.NOVEMBER },
    { month: "Dec", revenue: revenueData?.barChartData?.DECEMBER },
  ];

  const monthlyRevenue = [
    { month: "Week 1", revenue: revenueData?.barChartData?.week1 },
    { month: "Week 2", revenue: revenueData?.barChartData?.week2 },
    { month: "Week 3", revenue: revenueData?.barChartData?.week3 },
    { month: "Week 4", revenue: revenueData?.barChartData?.week4 },
  ];

  const weeklyRevenue = [
    { month: "Mon", revenue: revenueData?.barChartData?.MONDAY },
    { month: "Tue", revenue: revenueData?.barChartData?.TUESDAY },
    { month: "Wed", revenue: revenueData?.barChartData?.WEDNESDAY },
    { month: "Thur", revenue: revenueData?.barChartData?.THURSDAY },
    { month: "Fri", revenue: revenueData?.barChartData?.FRIDAY },
    { month: "Sat", revenue: revenueData?.barChartData?.SATURDAY },
    { month: "Sun", revenue: revenueData?.barChartData?.SUNDAY },
  ];
  const [showReverseModal, setShowReverseModal] = React.useState(false);
  const [selectedRowId, setSelectedRowId] = React.useState(null);
  const [showToolTipID, setShowToolTipID] = React.useState(null);
  const [serviceDetails, setServiceDetails] = React.useState({catgoryId: null, serviceId: null});

  const handleReverseClick = (clientId) => {
    setSelectedRowId(clientId);
    setShowReverseModal(true);
  };

  const isWithin48Hours = (dateUpdated) => {
    const now = new Date();
    const updated = new Date(dateUpdated);
    const diffHours = (now - updated) / (1000 * 60 * 60);
    return diffHours <= 48;
  };

  const isPassUsage = (activity) => {
    return activity?.toLowerCase().includes("pass usage");
  };

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {
            <div className="overview">
              {hasPermission(userRole, "OPERATOR") && (
                <div className="overview__utils">
                  <div
                    className="overview__utils--search"
                    onClick={() => setDropdown(true)}
                    onMouseLeave={() => setDropdown(false)}
                  >
                    <form className="overview__utils--clients">
                      <div className="search">
                        <Icon id="search-input" width={13} height={13} />
                        <input
                          type="text"
                          placeholder="Search Client"
                          onChange={(e) => setSearch(e.target.value)}
                          value={search}
                        />
                      </div>
                      <Button
                        variant={"bgBlue"}
                        borderType={"borderRight"}
                        onClick={(e) => handleSearch(e)}
                      >
                        Search
                      </Button>
                    </form>
                    {dropdown && (
                      <div className="search--dropdown">
                        {clLoading ? (
                          <div className="loader"></div>
                        ) : (
                          <>
                            {clientSearch.length > 0 && search ? (
                              <div className="results">
                                <p>Search Result</p>
                                <div className="results__body">
                                  <div className="list">
                                    {clientSearch.map((client) => (
                                      <div
                                        className="listName"
                                        index={client?.id}
                                        onClick={() =>
                                          navigate(
                                            `/clients/${client?.id}?clientType=${client?.clientType}`
                                          )
                                        }
                                      >
                                        <span>
                                          {client?.firstName?.charAt(0) +
                                            client?.lastName?.charAt(0)}
                                        </span>
                                        <p>
                                          {client?.firstName +
                                            " " +
                                            client?.lastName}
                                        </p>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            ) : clientSearch.length < 1 ? (
                              <>
                                {" "}
                                <div className="empty-search">
                                  <span>
                                    <Icon
                                      id="search-input"
                                      width={20}
                                      height={20}
                                    />
                                  </span>
                                  <h4>Client not found</h4>
                                  <p>
                                    No matching client was found. Please check
                                    the details and search again
                                  </p>
                                </div>
                              </>
                            ) : (
                              <div className="empty-search">
                                <span>
                                  <Icon
                                    id="search-input"
                                    width={20}
                                    height={20}
                                  />
                                </span>
                                <h4>Search for clients</h4>
                                <p>
                                  Find and manage client details quickly by
                                  searching with their name
                                </p>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="overview__utils--action">
                    <Button
                      variant={"primary"}
                      onClick={() => {
                        setOpenFlancePassModal(true);
                        getFromLocalStorage();
                      }}
                    >
                      ENTER Verification Code
                    </Button>
                  </div>
                </div>
              )}

              <DashboardCardSection
                userRole={userRole}
                clients={clients}
                providerCredit={providerCredit}
                clientVisit={clientVisit}
                revenueData={revenueData}
                yearlyRevenue={yearlyRevenue}
                monthlyRevenue={monthlyRevenue}
                weeklyRevenue={weeklyRevenue}
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
                openFilterList={openFilterList}
                setOpenFilterList={setOpenFilterList}
                filterOptions={filterOptions}
                skeletonLoading={skeletonLoading}
              />
              <div className="overview__container mt-6">
                <h4>Activity Log</h4>
                <div
                  className="overview__container--filter"
                  onMouseOver={() => setOpenClientFilterDropdown(true)}
                  onMouseLeave={() => setOpenClientFilterDropdown(false)}
                >
                  <Icon id="user-double" width="16" height="16" />
                  <div className="filter__dropdown">
                    <p>{selectedClientFilterDropdownItem?.name}</p>
                    <Icon id="arrow-down-small" width="16" height="16" />
                    {openClientFilterDropdown && (
                      <div className="filter__dropdown--list">
                        <ul>
                          {clientFilterOptions.map((item, index) => (
                            <li
                              onClick={() => {
                                setSelectedClientFilterDropdownItem(item);
                              }}
                            >
                              <p>{item?.name}</p>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <>
                {clientActivity?.content?.length > 0 ? (
                  <>
                    <div className="overview__table">
                      <div className="table-container">
                        <ActivityLog
                          data={clientActivity?.content}
                          clientType={clientType}
                          storedData={storedData}
                        />
                        {isActivityLoading ? (
                          <Spinner />
                        ) : (
                          <div className="smaller__table">
                            {clientActivity?.content?.map((client, index) => (
                              <MobileTable>
                                <div className="small__dashboard--table">
                                  <div className="smallTable__right">
                                    <div className="user">
                                      <div className="">
                                        <span>
                                          <Icon
                                            id={
                                              client?.clientType === "PROVIDER"
                                                ? "user-filled-non-flancer"
                                                : "user-filled-flancer"
                                            }
                                            width="40"
                                            height="40"
                                          />
                                        </span>
                                      </div>
                                      <div>
                                        <h3>
                                          {client?.firstName +
                                            " " +
                                            client?.lastName}
                                        </h3>
                                        <p className="date--deet">
                                          {dateFormat(
                                            client.dateCreated,
                                            "MMM dd, yyyy hh:mm a"
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                    <p className="deets activity">
                                      {client?.activity}
                                    </p>
                                  </div>
                                  <div className="smallTable__left">
                                    <p className="amount">
                                      {fmtCurrency(client?.amount)}
                                    </p>
                                  </div>
                                </div>

                                {client?.status === "REVERSED" ? (
                                  <div className="w-full flex justify-start gap-[12px] mt-[6px] items-center">
                                    <span className="text-[#029AFF] bg-[#E4F4FF] inline-flex justify-center items-center w-[80px] h-[24px] py-[8px] px-[12px] text-center font-[600] text-[10px] leading-[100%] tracking-[2%] uppercase rounded-full">
                                      <span>REVERSED</span>
                                    </span>

                                    <span className="inline-flex justify-start items-center font-[400] text-[10px] text-[#5C6368] leading-[150%] tracking-[0%] py-[6px]">
                                      {dateFormat(
                                        client.dateUpdated,
                                        "MMM dd, yyyy hh:mm a"
                                      )}
                                    </span>
                                  </div>
                                ) : (
                                  <div className="w-full relative flex justify-start gap-[12px] mt-[6px] items-center">
                                    <span className="text-[#3BAD54] bg-[#EBF7EE] inline-flex justify-center items-center w-[80px] h-[24px] py-[8px] px-[12px] text-center font-[600] text-[10px] leading-[100%] tracking-[2%] uppercase rounded-full">
                                      <span>APPROVED</span>
                                    </span>
                                    {hasPermission(
                                      userRole,
                                      "BRANCH_MANAGER"
                                    ) && (
                                      <>
                                        {isPassUsage(client?.activity) ? (
                                          <span
                                            onMouseEnter={() =>
                                              setShowToolTipID(client?.id)
                                            }
                                            onMouseLeave={() =>
                                              setShowToolTipID(null)
                                            }
                                            className="flex bg-[#F5F5F5]/60 justify-center gap-[6px] items-center w-[80px] h-[24px] font-[500] text-[#000B14] underline leading-[100%] tracking-[0%] rounded-[4px] py-[8px] px-[24px] cursor-pointer"
                                          >
                                            <span className="opacity-60 text-[10px]">
                                              Reverse
                                            </span>
                                            <Icon
                                              id="infoBlueSm"
                                              className="flex-shrink-0"
                                              width="8"
                                              height="8"
                                            />
                                            {showToolTipID === client?.id && (
                                              <div className="absolute z-50 flex top-full left-0 mt-3 w-[300px] opacity-100 bg-[#F5FBFF] rounded-lg shadow-lg px-4 pt-4 pb-3 items-start gap-[10px]">
                                                <Icon
                                                  id="infoBlue"
                                                  className="flex-shrink-0"
                                                  width="24"
                                                  height="24"
                                                />
                                                <span className="text-[#000B14] text-[12px] font-[600] leading-[24px] tracking-[0.5%]">
                                                  Pass Visits log cannot be
                                                  reversed.
                                                </span>
                                                <span
                                                  onClick={() =>
                                                    setShowToolTipID(null)
                                                  }
                                                >
                                                  <Icon
                                                    id="close"
                                                    width="16"
                                                    height="16"
                                                  />
                                                </span>
                                              </div>
                                            )}
                                          </span>
                                        ) : isWithin48Hours(
                                            client.dateUpdated ||
                                              client.dateCreated
                                          ) ? (
                                          <span
                                            onClick={() =>
                                              handleReverseClick(client?.id)
                                            }
                                            className="inline-flex hover:translate-y-[-2px] transition-all duration-300 bg-[#F5F5F5] justify-center items-center w-[80px] h-[24px] font-[500] text-[10px] text-[#000B14] underline leading-[100%] tracking-[0%] rounded-[4px] py-[8px] px-[24px] cursor-pointer"
                                          >
                                            Reverse
                                          </span>
                                        ) : (
                                          <span
                                            onMouseEnter={() =>
                                              setShowToolTipID(client?.id)
                                            }
                                            onMouseLeave={() =>
                                              setShowToolTipID(null)
                                            }
                                            className="flex bg-[#F5F5F5]/60 justify-center gap-[6px] items-center w-[80px] h-[24px] font-[500] text-[#000B14] underline leading-[100%] tracking-[0%] rounded-[4px] py-[8px] px-[24px] cursor-pointer"
                                          >
                                            <span className="opacity-60 text-[10px]">
                                              Reverse
                                            </span>
                                            <Icon
                                              id="infoBlueSm"
                                              className="flex-shrink-0"
                                              width="8"
                                              height="8"
                                            />
                                            {showToolTipID === client?.id && (
                                              <div className="absolute z-50 flex top-full left-0 mt-3 w-[300px] opacity-100 bg-[#F5FBFF] rounded-lg shadow-lg px-4 pt-4 pb-3 items-start gap-[10px]">
                                                <Icon
                                                  id="infoBlue"
                                                  className="flex-shrink-0"
                                                  width="24"
                                                  height="24"
                                                />
                                                <span className="text-[#000B14] text-[12px] font-[600] leading-[24px] tracking-[0.5%]">
                                                  Reverse unavailable
                                                  (transaction older than 48
                                                  hours).
                                                </span>
                                                <span
                                                  onClick={() =>
                                                    setShowToolTipID(null)
                                                  }
                                                >
                                                  <Icon
                                                    id="close"
                                                    width="16"
                                                    height="16"
                                                  />
                                                </span>
                                              </div>
                                            )}
                                          </span>
                                        )}
                                      </>
                                    )}
                                  </div>
                                )}
                              </MobileTable>
                            ))}
                          </div>
                        )}
                        <PaginationWithApi
                          setCurrentPage={setCurrentPage}
                          data={clientActivity}
                          handleNext={handleNext}
                          handlePrev={handlePrev}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="overview__table">
                    <div className="table-container">
                      <div className="mt-10 mb-10">
                        <ActiveBenefits
                          icon={skeletonLoading}
                          text={`This section will update as transactions are completed. all details will be displayed here for easy tracking!`}
                          centerHeight={false}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </>

              {openFlancePassModal && (
                <PassModal
                  openFlancePassModal={openFlancePassModal}
                  setOpenFlancePassModal={setOpenFlancePassModal}
                  storedData={storedData}
                  setOpenVerificationStatus={setOpenVerificationStatus}
                  setVerificationStatus={setVerificationStatus}
                  setVerifiedClientName={setVerifiedClientName}
                  setVerificationErrorMessage={setVerificationErrorMessage}
                  clientType={clientType}
                  setServiceDetails={setServiceDetails}
                />
              )}
              {showReverseModal && (
                <ReverseTransactionModal
                  transactionId={selectedRowId}
                  openReverseTransactionModal={showReverseModal}
                  setOpenReverseTransactionModal={setShowReverseModal}
                  clientType={clientType}
                  storedData={storedData}
                />
              )}
              {openVerificationStatus && (
              <PassVerificationStatusModal
                openFlancePassStatusModal={openVerificationStatus}
                isVisible={openVerificationStatus}
                setVerificationStatus={setVerificationStatus}
                setVerifiedClientName={setVerifiedClientName}
                handleClose={() => setOpenVerificationStatus(false)}
                status={verificationStatus}
                clientName={verifiedClientName}
                storedData={storedData}
                verificationErrorMessage={verificationErrorMessage}
                setVerificationErrorMessage={setVerificationErrorMessage}
                clientType={clientType}
                serviceDetails={serviceDetails}
                setServiceDetails={setServiceDetails}
              />
              )}
              <SuccessModal />
            </div>
          }
        </>
      )}
    </>
  );
};

export default Dashboard;

export const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          border: "1px solid #ccc",
          borderRadius: "8px",
          padding: "12px",
          boxShadow: "0px 1px 10px 0px #029AFF80;",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <p
            style={{
              color: "#5C6368",
              fontWeight: "400",
              fontSize: "12px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <span
              style={{
                display: "block",
                width: "10px",
                height: "10px",
                background: "#005397",
                borderRadius: "50%",
              }}
            ></span>
            Revenue:
          </p>
          <p style={{ color: "#000B14", fontWeight: 600 }}>
            {fmtCurrency(payload[0].value)}
          </p>
        </div>
      </div>
    );
  }
  return null;
};
